"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockLabelProperty = exports.infoBlockLabelPropertyDefinition = void 0;
exports.infoBlockLabelPropertyDefinition = {
    view: {
        label: 'Label',
        hint: 'Concise kicker text that supports the title and teaser. Example: Step 1 or Prize for the Finalists',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 70,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'info-block-label',
};
const isInfoBlockLabelProperty = (prop) => {
    return prop.name === exports.infoBlockLabelPropertyDefinition.name;
};
exports.isInfoBlockLabelProperty = isInfoBlockLabelProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1sYWJlbC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stbGFiZWwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsT0FBTztRQUNkLElBQUksRUFBRSxvR0FBb0c7S0FDM0c7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsa0JBQWtCO0NBQ08sQ0FBQTtBQUkxQixNQUFNLHdCQUF3QixHQUFHLENBQUMsSUFBa0IsRUFBa0MsRUFBRTtJQUM3RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssd0NBQWdDLENBQUMsSUFBSSxDQUFBO0FBQzVELENBQUMsQ0FBQTtBQUZZLFFBQUEsd0JBQXdCLDRCQUVwQyJ9